<!--
[INPUT]: 依赖同模块代码与项目公共基础设施能力
[OUTPUT]: 对外提供 Cashier 相关页面或组件实现
[POS]: 位于 jeepay-ui\jeepay-ui-cashier\src\views，视图层实现，负责页面呈现与交互流程
[PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
-->
<template>
  <router-view></router-view>
</template>

<script>

export default {
  components: {
  },
  mounted() {
    console.log("进入cashier页面");
  }

}
</script>
